'use client';

import React from 'react';
import type { Form } from '../../payload-types';
import { isBookingMode, resolveBookingPage, type BookingMode } from '../../utilities/forms/booking-page';
import ContactFormClient from './contact-form-client';
import CalendlyEmbed from './calendly-embed';

/** Each booking mode's Booking Page, shown inline in the page. */
const BOOKING_PAGE_EMBEDS: Record<BookingMode, React.FC<{ form: Form; url: string }>> = {
  calendly: CalendlyEmbed,
};

const IntegrationForm: React.FC<{
  form: Form;
  successText?: string | null;
  layout?: 'contact-panel';
  submitText?: string;
}> = ({ form, successText, layout, submitText }) => {
  const bookingPage = resolveBookingPage(form);

  if (bookingPage) {
    const BookingPageEmbed = BOOKING_PAGE_EMBEDS[bookingPage.mode];
    return <BookingPageEmbed form={form} url={bookingPage.url} />;
  }

  // A booking Form never shows fields: one with no Booking Page (its link is
  // empty) shows nothing.
  if (isBookingMode(form.integrationMode)) { return null; }

  // Both AC and internal use the same form fields + submission hook.
  // The server action branches based on integrationMode.
  return <ContactFormClient form={form} successText={successText} layout={layout} submitText={submitText} />;
};

export default IntegrationForm;
